import { render, staticRenderFns } from "./StoreFileBlobList.vue?vue&type=template&id=486dcb42&"
import script from "./StoreFileBlobList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StoreFileBlobList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports